import React, { useState, useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import Field from '../../Wizard/Field/Field';

export default function EditMaintenance(props) {
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();

    const [resource, setResource] = useState({});
    const [editMaintenance, setEditMaintenance] = useState({});
    const [maintenanceTypes, setMaintenanceTypes] = useState<Array<any>>([])
    const [editMaintenanceTypeId, setEditMaintenanceTypeId] = useState("");

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    function handleCloseModal() {
        props.setShowEditMaintenance(false);
        setResource({});
        setEditMaintenance({});
        setMaintenanceTypes([]);
        setEditMaintenanceTypeId("");
    }


    function handleEditMaintenance() {
        let tempDate = new Date();
        let tempMaintenance = {
            ...editMaintenance,
            type: maintenanceTypes.find(i => i["_id"] == editMaintenanceTypeId),
            finished: tempDate,
            finishedBy: auth.user["userdata"]["name"]
        };

        if(tempMaintenance["name"] == "" || tempMaintenance["name"] == undefined) { notifyWarning(t("maintenance.toast_maintenance_empty_name")); return undefined; }
        if(tempMaintenance["type"] == "" || tempMaintenance["type"] == undefined) { notifyWarning(t("maintenance.toast_maintenance_empty_type")); return undefined; }
        if(tempMaintenance["priority"] == "" || tempMaintenance["priority"] == undefined) { notifyWarning(t("maintenance.toast_maintenance_empty_priority")); return undefined; }

        axios.put(
            "/api/resources/maintenance/" + resource["_id"],
            {
                maintenance: tempMaintenance
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(
            () => { props.runOnEdit(); handleCloseModal() })

    }


    function handleDeleteMaintenance(evt) {
        let tempMaintenance = editMaintenance;

        axios.put(
            "/api/resources/deleteMaintenance/" + resource["_id"],
            {
                maintenance: tempMaintenance
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(
            () => { if(props.runOnEdit != undefined){props.runOnEdit()}; 
                handleCloseModal(); })

    }

    useEffect(() => {
        if (props.showEditMaintenance) {
            axios.all([
                axios.single({
                    method: "get",
                    url: "/api/resources/" + props.resourceID,
                    responseType: "json",
                    headers: { 'x-access-token': auth.user["token"] }
                }),
                axios.single({
                    method: "get",
                    url: "/api/maintenancetypes/",
                    responseType: "json",
                    headers: { 'x-access-token': auth.user["token"] }
                })

            ]).then(axios.spread((...res) => {
                setResource(res[0].data);
                setEditMaintenance(res[0].data["maintenance"][props.maintenanceKey]);
                setEditMaintenanceTypeId(res[0].data["maintenance"][props.maintenanceKey]["type"]["_id"])
                setMaintenanceTypes(res[1].data);
            })).catch(err => console.log(err))
        }
    }, [props.showEditMaintenance])

    const setEditMaintenanceName = value => { setEditMaintenance(editMaintenance => ({ ...editMaintenance, name: value })); };
    //const setEditMaintenanceType = value => { setEditMaintenance(editMaintenance => ({ ...editMaintenance, type: value })); };
    const setEditMaintenancePriority = value => { setEditMaintenance(editMaintenance => ({ ...editMaintenance, priority: value })); };
    const setEditMaintenanceDescription = value => { setEditMaintenance(editMaintenance => ({ ...editMaintenance, description: value })); };
    const setEditMaintenanceDone = value => { setEditMaintenance(editMaintenance => ({ ...editMaintenance, done: value })); };




    return (
        <>
            <Modal show={props.showEditMaintenance} onHide={() => handleCloseModal()} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("maintenance.edit_title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("maintenance.new_name")}
                        value={editMaintenance["name"]}
                        onChange={val => setEditMaintenanceName(val)}
                    />
                    <Field
                        type="select"
                        title={t("maintenance.new_type")}
                        value={{ value: editMaintenanceTypeId }}
                        onChange={val => setEditMaintenanceTypeId(val.value)}
                        options={{
                            choosetext: t("maintenance.choosetext_type"),
                            choices: maintenanceTypes != undefined ? (maintenanceTypes.map(i => { return { label: i["name"], value: i["_id"] } })) : null
                        }}
                    />
                    <Field
                        type="select"
                        title={t("maintenance.new_priority")}
                        value={{ value: editMaintenance["priority"] }}
                        onChange={val => setEditMaintenancePriority(val.value)}
                        options={{
                            choosetext: t("maintenance.choosetext_priority"),
                            choices: [
                                { label: t("maintenance.priority_low"), value: "low" },
                                { label: t("maintenance.priority_medium"), value: "medium" },
                                { label: t("maintenance.priority_high"), value: "high" },
                            ]
                        }}
                    />
                    <Field
                        type="textarea"
                        title={t("maintenance.new_description")}
                        value={editMaintenance["description"]}
                        onChange={val => setEditMaintenanceDescription(val)}
                    />
                    <Field
                        type="checkbox"
                        title={t("maintenance.new_done")}
                        value={editMaintenance["done"]}
                        onChange={val => setEditMaintenanceDone(val)}
                    />
                    <Button style={{float: "right"}} onClick={handleDeleteMaintenance}>
                        {t("maintenance.delete")}
                    </Button>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseModal}>
                        {t("maintenance.cancel")}
                    </Button>
                    <Button onClick={() => { handleEditMaintenance(); }}>
                        {t("maintenance.save")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )

}